import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b8aba83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "kefu-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "私人客服", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kefu-divider" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "官方微信", -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]

import { ElConfigProvider } from "element-plus";
import zhCN from 'element-plus/dist/locale/zh-cn'
import zhTW from 'element-plus/dist/locale/zh-tw'
import en from 'element-plus/dist/locale/en'
import {onUnmounted, reactive, ref} from "vue"
import { lnguage, web_site} from '@/api/services'
import { useStore } from 'vuex'
import {useI18n} from "vue-i18n";



export default /*#__PURE__*/_defineComponent({
  __name: 'layout',
  setup(__props) {

const store = useStore()
const language = ref('zh-CN')
const locale = ref('zhCN')
//初始化项目
const i18n = useI18n();

/*
//客服微信
const keFu = reactive({
    isHide:false,
    isShow:false,
    wechat_kefu:'',
});
*/
// 客服信息
const keFu = reactive({
  active: null as null | 1 | 2,
  wechat_kefu_1: '',
  wechat_kefu: ''
})


initSystem()

function initSystem() {
  getLanguage()
  greet()
}

//获取语言
function getLanguage(){
  lnguage().then((res) => {
    store.commit('setLanguageList', res.data)
    if(store.state.selectLanguage == ''){
      store.commit('setSelectLanguage', res.data[0].code)
      store.commit('setSelectLanguageName', res.data[0].name)
    }
    language.value = res.data[0].code
  }).catch((err) => {
    console.log("err");
  });
}

//获取站点配置
// 系统信息
web_site().then((res) => {
  keFu.wechat_kefu_1 = res.data.wechat_kefu
  keFu.wechat_kefu= res.data.wechat_kefu
  store.commit('setWebSite', res.data)
}).catch((err) => {
  console.log("appinfo err");
});

function greet() {
  i18n.locale.value = store.state.selectLanguage.replace(/-/g, "")
  //console.log(store.state.selectLanguage.replace(/-/g, ""))
  //locale.value = store.state.selectLanguage.replace(/-/g, "");
  //locale.value = store.state.selectLanguage.replace(/-/g, "")
  if(store.state.selectLanguage === 'zh-CN'){
    locale.value = zhCN
  }
  if(store.state.selectLanguage === 'zh-TW'){
    locale.value = zhTW
  }
  if(store.state.selectLanguage === 'en'){
    locale.value = en
  }
  if(store.state.selectLanguage === 'th-TH'){
    locale.value = en
  }
}
// 切换显示哪个客服图
function toggleKefu(index: 1 | 2) {
  keFu.active = keFu.active === index ? null : index
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_User = _resolveComponent("User")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ChatDotSquare = _resolveComponent("ChatDotSquare")!
  const _component_el_affix = _resolveComponent("el-affix")!

  return (_openBlock(), _createBlock(_unref(ElConfigProvider), {
    locale: locale.value,
    size: "large"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view),
      (_unref(store).state.userInfo && _unref(store).state.userInfo.is_sub_user === false)
        ? (_openBlock(), _createBlock(_component_el_affix, {
            key: 0,
            style: _normalizeStyle({ position: 'fixed', top: '80%', right: '10px','z-index':'99', transform: 'translateY(-50%)' })
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", {
                  class: "kefu-btn",
                  onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (toggleKefu(1))),
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (toggleKefu(null)))
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_User)
                    ]),
                    _: 1
                  }),
                  _hoisted_2
                ], 32),
                _hoisted_3,
                _createElementVNode("div", {
                  class: "kefu-btn",
                  onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (toggleKefu(2))),
                  onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (toggleKefu(null)))
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ChatDotSquare)
                    ]),
                    _: 1
                  }),
                  _hoisted_4
                ], 32)
              ]),
              (keFu.active === 1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: keFu.wechat_kefu_1,
                    class: "kefu-img"
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true),
              (keFu.active === 2)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: keFu.wechat_kefu,
                    class: "kefu-img"
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["style"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})